import {initAccordion} from "../Components/Accordion/Accordion";
import {initHeader} from "../Components/Header/Header";
import {initForm} from "../Components/Form/Form";
import {initFormFields} from "../Components/FormField/FormField";
import {initNotification} from "../Components/Notification/Notification";
import {initLoanPart} from "../Components/LoanPart/LoanPart";
import {initCookieConsent} from "../Components/CookieConsent/CookieConsent";
import {initUpload} from "../Components/Upload/Upload";
import {createDialog} from "../Components/Dialog/Dialog";
import {initInputMasks} from "./utils/inputMasking";
import {initInputFormatters} from "./utils/formFormatter";

function initAll() {
    document.querySelectorAll("header.header").forEach(initHeader);
    document.querySelectorAll("[data-accordion]").forEach(initAccordion);
    document.querySelectorAll("form[data-sds-form]").forEach(initForm);
    document.querySelectorAll("[data-sds-notification]").forEach(initNotification);
    document.querySelectorAll(".loan-part").forEach((el) => initLoanPart(el));
    document.querySelectorAll('[data-upload]').forEach(initUpload);
    document.querySelectorAll(".cookie-consent").forEach(initCookieConsent);
    initFormFields();
    initInputFormatters();
    initInputMasks();
    
    window.dialog = createDialog(document.getElementById("dialog"));
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll, { once: true });
} else {
    initAll();
}